module.exports = __webpack_public_path__ + "public/fonts/RWSTTDd.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/fonts/RWSTTDd.woff2
// module id = 696
// module chunks = 0